import React from 'react';
import PropTypes from 'prop-types';
import DrugInformation from './components/DrugInformation/DrugInformation';
import PlanIdNetwork from './components/PlanIDNetwork/PlanIDNetwork';
import PlanDrugCosts from './components/PlanDrugCosts/PlanDrugCosts';

function MedicareResult({
  medicareDrugInformation,
  medicarePlanInformation,
  drugTier,
  zipCode,
  drugName,
}) {
  return (
    <>
      <h4 className="mobile-title-text text-truncate">
        Coverage Type: <span className="text-primary">Medicare</span>
      </h4>
      <div className="drug-content">
        <div className="drug-tabs">
          <ul className="nav nav-pills  flex-row" id="pills-tab" role="tablist">
            <li className="nav-item" role="presentation">
              <button
                className="nav-link active"
                id="pills-medicare-home-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-home1-medicare"
                type="button"
                role="tab"
                aria-controls="pills-home"
                aria-selected="true"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={18}
                  height={18}
                  viewBox="0 0 24 24"
                  fill="currentColor"
                  className="icon icon-tabler icons-tabler-filled icon-tabler-pill"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M20.207 3.793a5.95 5.95 0 0 1 0 8.414l-8 8a5.95 5.95 0 0 1 -8.414 -8.414l8 -8a5.95 5.95 0 0 1 8.414 0m-7 1.414l-4.294 4.293l5.586 5.586l4.294 -4.292a3.95 3.95 0 1 0 -5.586 -5.586"></path>
                </svg>
                Drug Information
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-drug-costs-tab-medicare"
                data-bs-toggle="pill"
                data-bs-target="#pills-drug-costs-medicare"
                type="button"
                role="tab"
                aria-controls="pills-drug-costs"
                aria-selected="true"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={18}
                  height={18}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-library"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M7 3m0 2.667a2.667 2.667 0 0 1 2.667 -2.667h8.666a2.667 2.667 0 0 1 2.667 2.667v8.666a2.667 2.667 0 0 1 -2.667 2.667h-8.666a2.667 2.667 0 0 1 -2.667 -2.667z"></path>
                  <path d="M4.012 7.26a2.005 2.005 0 0 0 -1.012 1.737v10c0 1.1 .9 2 2 2h10c.75 0 1.158 -.385 1.5 -1"></path>
                  <path d="M11 7h5" />
                  <path d="M11 10h6" />
                  <path d="M11 13h3" />
                </svg>
                Plan &amp; Drug Costs
              </button>
            </li>
            <li className="nav-item" role="presentation">
              <button
                className="nav-link"
                id="pills-medicare-network-tab"
                data-bs-toggle="pill"
                data-bs-target="#pills-network-medicare"
                type="button"
                role="tab"
                aria-controls="pills-network"
                aria-selected="true"
              >
                {' '}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width={18}
                  height={18}
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  className="icon icon-tabler icons-tabler-outline icon-tabler-cash"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                  <path d="M7 9m0 2a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
                  <path d="M14 14m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"></path>
                  <path d="M17 9v-2a2 2 0 0 0 -2 -2h-10a2 2 0 0 0 -2 2v6a2 2 0 0 0 2 2h2"></path>
                </svg>
                Plan &amp; Network
              </button>
            </li>
          </ul>
          <div
            className="tab-content drug-detail-content"
            id="pills-tabContent"
          >
            <DrugInformation
              medicareDrugInfo={medicareDrugInformation}
              drugName={drugName}
            />
            <PlanIdNetwork
              medicarePlanInfo={medicarePlanInformation}
              zipCode={zipCode}
            />
            <PlanDrugCosts
              medicarePlanInfo={medicarePlanInformation}
              drugTier={drugTier}
            />
          </div>
        </div>
      </div>
    </>
  );
}

MedicareResult.propTypes = {
  medicarePlanInformation: PropTypes.object.isRequired,
  medicareDrugInformation: PropTypes.object.isRequired,
  drugTier: PropTypes.string.isRequired,
  zipCode: PropTypes.string.isRequired,
};

export default MedicareResult;
